export enum UserPageTab {
  PROGRESS = "progress",
  PROFILE = "profile",
  STOCK = "stock",
  MESSAGE = "message",
  PLAN = "plan",
}

export enum ProgressSubTab {
  COURSE_CHART = "course_chart",
  COURSE_CLEARED = "course_cleared",
  CREATOR_CHART = "creator_chart",
  CREATOR_PROJECT = "creator_project",
}

export enum PlanSubTab {
  CURRENT = "current",
  PURCHASE = "purchase",
}
